import { Box, Flex, Text } from '@chakra-ui/react';
import { getIn } from 'formik';
import React from 'react';

import { ReportTemplateContainer } from './template/ReportTemplateContainer';
import { SaveIconButton } from 'packages/common-frontend/components/IconButton';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { CreditAgreementFullArtifactWipConfigType } from 'packages/creditAgreements/ui/types';

export const ReportingOutputDocxConfig: React.FC<{
  outputConfig: CreditAgreement.Config.Reporting.Outputs.Docx.Config;
  reportConfigTypes: CreditAgreement.DomainEntity.ReportConfigType[];
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
  basePropertyKey: string;
}> = ({ outputConfig, reportConfigTypes, wipConfig, basePropertyKey }) => {
  const { template } = outputConfig;

  return (
    <Box id="reporting-output-config-container">
      <Flex alignItems="center" mb="3">
        <Text as="h2" fontWeight="bold" fontSize="xl" mr="2">
          Output Config
        </Text>
        {wipConfig?.isMutateAllowed(basePropertyKey) && (
          <>
            <SaveIconButton
              ariaLabel="save output config"
              label="Save Output Config"
              onClick={() => {
                const newOutputConfig = getIn(
                  wipConfig.formProps.values,
                  basePropertyKey,
                );

                // @DOCX TODO: add typeguard check on "newOutputConfig" for Output.Docx.Config

                wipConfig.saveAndUpdateConfigCreditAgreementWip({
                  wipConfig,
                  propertyKey: basePropertyKey,
                  updatedProperty: newOutputConfig,
                });
              }}
            />
          </>
        )}
      </Flex>

      <ReportTemplateContainer
        reportConfigType={reportConfigTypes[0]}
        templateConfig={template}
        templatePropertyKey={`${basePropertyKey}.template`}
        wipConfig={wipConfig}
        fileType="docx"
      />
    </Box>
  );
};
